import { schema } from 'normalizr';
import channel from './channel';

const eventSchema = new schema.Entity('events', {
  channel,
});

export default eventSchema;
